<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary py-2 admin-title"
                                  style="word-break: normal">EDITAR BANNER
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                    <v-card>
                        <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                        <v-card-text>
                            <v-row justify="center">
                                <v-col cols="12" sm="11">
                                    <v-switch
                                        v-model="form.active"
                                        inset
                                        color="success"
                                        label="Mostrar banner en Inicio"
                                        :disabled="loading"/>
                                    <v-divider/>
                                </v-col>
                                <v-col cols="12" sm="11">
                                    <v-card outlined>
                                        <v-card-text>
                                            <v-row dense align="center">
                                                <v-col cols="12" md="7">
                                                    <v-file-input
                                                        v-model="image"
                                                        accept="image/*"
                                                        prepend-icon="mdi-image-plus"
                                                        label="Subir imagen para el banner"
                                                        :disabled="loading || uploading"
                                                        hide-details/>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-btn color="primary" block depressed :loading="uploading" :disabled="!image || loading" @click="uploadImage">
                                                        <v-icon>mdi-cloud-upload</v-icon>&nbsp;&nbsp;Subir
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="12" md="2">
                                                    <v-btn color="success" block depressed :disabled="!lastImageUrl" @click="insertImage">
                                                        <v-icon>mdi-plus-box</v-icon>&nbsp;&nbsp;Insertar
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-alert type="success" outlined dense class="mt-4 mb-0" v-if="lastImageUrl">
                                                Imagen lista para insertar: <strong>{{ lastImageUrl }}</strong>
                                            </v-alert>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="11">
                                    <ckeditor v-model="form.content" :editorUrl="editorUrl" :config="editorConfig"/>
                                </v-col>
                                <v-col cols="12" sm="11" v-if="form.content">
                                    <h3 class="font-weight-bold mb-2">Previsualización</h3>
                                    <v-card outlined>
                                        <v-card-text class="banner-preview" v-html="form.content"/>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="12" sm="6" md="5">
                                    <v-btn type="submit" class="mt-6" block large :loading="loading" color="success" :disabled="loading || !valid">
                                        <v-icon>mdi-reload</v-icon><span>&nbsp;&nbsp;Actualizar</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "Banner",
    mixins: [ Form ],
    props: [ 'user' ],
    data: () => ({
        loading: false,
        uploading: false,
        image: null,
        lastImageUrl: null,
        form: {
            active: false,
            content: null
        },
        editorUrl: 'https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js',
        editorConfig: {
            toolbarGroups: [
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'forms', groups: [ 'forms' ] },
                '/',
                { name: 'colors', groups: [ 'colors' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                '/',
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'others', groups: [ 'others' ] },
                { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons: 'Save,NewPage,Preview,Print,Templates,Flash,Maximize,ShowBlocks,About',
            removeDialogTabs: 'image:advanced;link:advanced',
            autoParagraph: false,
            format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
            extraAllowedContent: 'span;ul;li;table;th;td;center;br;style;*[id];*(*);*{*}',
            resize_enabled: false,
            enterMode: 'CKEDITOR.ENTER_P',
            shiftEnterMode: 'CKEDITOR.ENTER_BR',
            toolbarCanCollapse: true,
            language: 'es',
            height: '300'
        }
    }),
    created () {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;

            axios.get('/api/settings/banner').then((res) => {
                this.form.active = res.data.active;
                this.form.content = res.data.content;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            }).then(() => {
                this.loading = false;
            });
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;

                axios.post('/api/settings/banner', this.form).then(res => {
                    if (res.data.v === 'success') {
                        this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    } else {
                        this.$toast.warning(res.data.status, {
                            timeout: 8000,
                            icon: 'mdi-information',
                            dismissable: false,
                            showClose: true
                        });
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
            }
        },
        uploadImage() {
            if (!this.image) {
                return;
            }

            this.uploading = true;
            const formData = new FormData();
            formData.append('image', this.image);

            axios.post('/api/settings/banner/image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                this.lastImageUrl = res.data.url;
                this.image = null;
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            }).then(() => {
                this.uploading = false;
            });
        },
        insertImage() {
            if (!this.lastImageUrl) {
                return;
            }

            const image = '<p><img src="' + this.lastImageUrl + '" alt="Banner" style="max-width:100%;height:auto;" /></p>';
            this.form.content = (this.form.content || '') + image;
        }
    }
}
</script>

<style scoped>
.admin-title {
    background-color: #0b3558 !important;
    color: #f6c343 !important;
    text-shadow: none !important;
}

.banner-preview >>> img {
    max-width: 100%;
    height: auto !important;
}
</style>
